import React, { useState, useEffect } from 'react';
import {
    EuiText,
    EuiButton,
    EuiFlexGroup,
    EuiFlexItem,
    EuiComboBox,
    EuiFieldText,
    EuiForm,
    EuiFormRow,
    EuiLoadingSpinner,
    EuiPanel,
    EuiSpacer,
    EuiCard,
    EuiProgress,
    EuiModal,
    EuiModalHeader,
    EuiModalHeaderTitle,
    EuiModalBody,
    EuiFieldPassword,
    EuiModalFooter, EuiButtonEmpty,
} from '@elastic/eui';
import {CatalystSelection} from "./CatalystSelection";
import "./Topbar.css"
import {BatchTable} from "./table/BatchTable";

interface Batch {
    batchId: number;
    batchName: string;
    createdDate: string;
    numberOfPins: number;
    status: string;
}

interface PinData {
    pin: number;
    batchName: string;
}

interface option{
    "label":string,
    "value": any
};



const ManagePinComponent: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [batches, setBatches] = useState<Batch[]>([]);
    const [options,setOptions] = useState([{"label":"","value":""}])
    const [selectedBatchData,setSelectedBatchData] = useState();
    const [batchId,setBatchId] = useState<number>();
    const [pinValue,setPinValue] = useState("");
    const [isPinLoading,setPinLoading] = useState(false);
    const [isSellPinModalVisible, setSetSellPinIsModalVisible] = useState(false);

    useEffect(()=>{console.log(selectedBatchData); console.log(batchId)},[selectedBatchData])

    const fetchBatches = async () => {
        setLoading(true);

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/v1/batch', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await response.json();

            let opts = data.map((bat: { batchId: any; batchName: any; } )=> {return {"label": bat.batchName,"value":bat.batchId} })
            setOptions(opts)


            setBatches(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching batch data:', error);
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchBatches();
    }, []);

    const handleGetPin = async () => {
        if (selectedBatchData) {
            setPinLoading(true);

            try {
                const token = localStorage.getItem('token');
                var id;
                if(selectedBatchData){ // @ts-ignore
                    id = selectedBatchData[0].value }
                const response = await fetch('/api/v1/pin/singlepin', {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ batchId : id  }),
                });
                const data = await response.json();
                console.log(data)
                setPinValue(data.pin)


                setPinLoading(false);
            } catch (error) {
                console.error('Error fetching pin data:', error);
                setLoading(false);
            }
        }
    };


    function getSellButton(): NonNullable<React.ReactNode> | undefined {
        if(pinValue==""){return ""}else {
            return( <EuiButton onClick={()=>{setSetSellPinIsModalVisible(true)}}>Sell Pin</EuiButton>)
        }
    }

    async function callSellApi() {

            // const phoneNumber = '1234567890'; // Replace with the phone number you want to forward
            //
            //
            // const message = 'The vpn pin for spl_vpn is : '+ pinValue;
            //
            // const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
            //
            // window.open(url, '_blank');



        const token = localStorage.getItem('token');
        const response = await fetch('/api/v1/pin/pinsold', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({pin: pinValue}),
        });

        console.log(response.text().then((val)=>{if(val=="changed"){
            alert("status changed to sold");
            setPinValue("");
            setSetSellPinIsModalVisible(false);
        }else {
            alert("server error occured")
        }}))

    }

    function refreshData() {
        fetchBatches();
    }

    return (
        <div>
            <div className="top-bar-inside">
                <div className="containeroftopbar">
                    <div className="logo-inside">Manage pin</div>
                </div>
            </div>
            <EuiPanel style={{margin:"3%"}}>
                {loading ? (
                       <EuiProgress size="xs" color="accent" />

                ) : (
                    <EuiFlexGroup>
                        <EuiFlexItem>
                    <EuiForm>

                        <EuiFormRow>
                            <CatalystSelection options={options} addAll={false} labelName={"Batch"} multiSelect={false} selectedOptions={(opt:any)=>
                            {
                                setSelectedBatchData(opt)}

                            }></CatalystSelection>

                        </EuiFormRow>

                        <EuiSpacer />

                        <EuiFormRow>
                            <EuiButton onClick={handleGetPin}>Get Pin</EuiButton>
                        </EuiFormRow>
                    </EuiForm>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            { isPinLoading ? ( <EuiProgress size="xs" color="accent" />): (<EuiCard

                                paddingSize="s"
                                title={pinValue||""}
                                description={getSellButton()}
                                titleElement="h6"
                                betaBadgeProps={{
                                    label: 'Generated pin',
                                    tooltipContent:
                                        'Select a batch and press get pin to get a single pin',
                                }}
                                onClick={() => {}}
                            />) }

                        </EuiFlexItem>
                    </EuiFlexGroup>
                )}

            </EuiPanel>
            <EuiPanel style={{margin:"3%"}}>
                {loading ? (
                    <EuiProgress size="xs" color="accent" />):
                    <BatchTable onChildChange={refreshData} batches={batches}></BatchTable>
                }

            </EuiPanel>
            {isSellPinModalVisible && (
                <EuiModal onClose={() => setSetSellPinIsModalVisible(false)}>
                    <EuiModalHeader>
                        <EuiModalHeaderTitle>Sell</EuiModalHeaderTitle>
                    </EuiModalHeader>
                    <EuiModalBody>
                        <EuiText>change the following pins status to sold:</EuiText><br/>
                        <EuiText>{pinValue}</EuiText>
                    </EuiModalBody>
                    <EuiModalFooter>
                        <EuiButtonEmpty onClick={() => setSetSellPinIsModalVisible(false)}>Cancel</EuiButtonEmpty>
                        <EuiButton onClick={callSellApi} fill>
                            Confirm
                        </EuiButton>
                    </EuiModalFooter>
                </EuiModal>
            )}

        </div>
    );
};

export default ManagePinComponent;